import React, { useId } from "react";
import { Box } from "@mui/material";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { DASH } from "../../pages/Dashboard/dashboardTheme";
import ChartTooltip from "./ChartTooltip";

/** Gráfica de área para tendencias (servicios, actividad, etc.). */
export default function TrendAreaChart({
  data = [],
  dataKey = "count",
  labelKey = "label",
  height = 200,
  stroke = "#111110",
  valueLabel = "",
  compact = false,
  showGrid = true,
  xInterval = "preserveStartEnd",
}) {
  const gradId = useId().replace(/:/g, "");

  return (
    <Box sx={{ width: "100%", height }}>
      <ResponsiveContainer>
        <AreaChart
          data={data}
          margin={{ top: 4, right: 4, left: compact ? -28 : -24, bottom: 0 }}
        >
          <defs>
            <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={stroke} stopOpacity={0.1} />
              <stop offset="100%" stopColor={stroke} stopOpacity={0} />
            </linearGradient>
          </defs>
          {showGrid && (
            <CartesianGrid strokeDasharray="3 3" stroke={DASH.borderLight} vertical={false} />
          )}
          <XAxis
            dataKey={labelKey}
            tick={{ fontSize: compact ? 9 : 10, fill: DASH.textMuted }}
            axisLine={false}
            tickLine={false}
            interval={xInterval}
          />
          <YAxis
            tick={{ fontSize: compact ? 9 : 10, fill: DASH.textMuted }}
            axisLine={false}
            tickLine={false}
            allowDecimals={false}
          />
          <Tooltip content={<ChartTooltip valueLabel={valueLabel} />} />
          <Area
            type="monotone"
            dataKey={dataKey}
            stroke={stroke}
            strokeWidth={1.5}
            fill={`url(#${gradId})`}
            dot={false}
            activeDot={{ r: 4, fill: stroke, strokeWidth: 0 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
}
